import { createTypedValidator } from '@takeshape/json-schema';
export const shapeName = 'TSAgentAttachment';
export const schema = {
    type: 'object',
    properties: {
        data: {
            type: 'string',
            description: 'A base64 encoded string of the attachment data.'
        },
        filename: {
            type: 'string',
            description: 'The optional filename of the attachment.'
        },
        mediaType: {
            type: 'string',
            description: 'IANA media type of the file.\n\n@see https://www.iana.org/assignments/media-types/media-types.xhtml'
        }
    },
    required: ['data', 'mediaType'],
    additionalProperties: false
};
export const validate = createTypedValidator(schema);
